"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

require("./toggle.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Toggle = function Toggle(_ref) {
  var id = _ref.id,
      isOn = _ref.isOn,
      handleToggle = _ref.handleToggle,
      className = _ref.className;
  var computedClassName = (0, _classnames.default)(className, {
    'bg-primary': isOn,
    'react-toggle-off': !isOn
  }, 'react-toggle-label');
  return _react.default.createElement(_react.default.Fragment, null, _react.default.createElement("input", {
    checked: isOn,
    onChange: handleToggle,
    className: "react-toggle-checkbox",
    id: id,
    type: "checkbox"
  }), _react.default.createElement("label", {
    className: computedClassName,
    htmlFor: id
  }, _react.default.createElement("span", {
    className: "react-toggle-button"
  })));
};

var _default = Toggle;
exports.default = _default;